import React from 'react';

import Modal from '@components/common/Modals/Modal/Modal';
import NotificationCard from '@components/lpc/Pot/MainModule/Activity/Notification/NotificationCard/NotificationCard';
import { personRoles } from '@models/PotModel/personRoles';
import { AvatarType } from '@propTypes/userTypes';

import css from './ParticipantModal.module.scss';

type ParticipantModalProps = {
    isVisible: boolean;
    onHide: () => void;
    potRef: string;
    personRole: string;
    setOpenParticipantModal: (value: boolean) => void;
    avatar: AvatarType;
    contribution: number;
    firstName: string;
    lastName: string;
    hideContribution: boolean;
    hideName: boolean;
    contributionDate: string;
    orderId: string;
    inviteID: number;
    handleParticipantRefunded: () => void;
};

const ParticipantModal = ({
    isVisible,
    onHide,
    potRef,
    personRole,
    setOpenParticipantModal,
    avatar,
    contribution,
    firstName,
    lastName,
    hideContribution,
    hideName,
    contributionDate,
    orderId,
    inviteID,
    handleParticipantRefunded,
}: ParticipantModalProps) => {
    return (
        <Modal visible={isVisible} onHide={onHide} customClass={css.parent_modal}>
            <div className={css.participant_modal} id={'notifContainer'}>
                <NotificationCard
                    orderId={orderId}
                    inviteID={inviteID}
                    message={null}
                    hideName={hideName}
                    hideContribution={hideContribution}
                    contribution={contribution}
                    onUpdateActivities={null}
                    id={null}
                    avatar={avatar}
                    firstName={firstName}
                    lastName={lastName}
                    creationDate={contributionDate}
                    type={null}
                    isOrganiser={personRole === personRoles.ORGANISER}
                    personRole={personRole}
                    potRef={potRef}
                    setOpenParticipantModal={setOpenParticipantModal}
                    handleParticipantRefunded={handleParticipantRefunded}
                />
            </div>
        </Modal>
    );
};

export default ParticipantModal;
